<template>
    <div>
        <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
          <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <el-button size="small" type="danger" @click="saveData()">
                {{form.id == '' ? '下一步' : '保 存'}}

            </el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="160px">
          <el-form-item label="话术" prop="userAllWords">
            <el-input v-model="form.userAllWords" placeholder="话术" ></el-input>
            <span style="color: red"></span>
          </el-form-item>
          <el-form-item label="关键词" prop="userKeyWords">
            <el-input v-model="form.userKeyWords" placeholder="关键词" ></el-input>
            <span style="color: red">写出本次话术的关键语句，用于在聊天记录中对比，多条之间用半角逗号(",")分割，不超过5条</span>
          </el-form-item>

            <el-form-item label="用户分类" prop="userClass" >
                <el-select v-model="form.userClass"

                           placeholder="用户分类">
                    <el-option
                            v-for="item in userClassData"
                            :key="item.dictionaryName"
                            :label="item.dictionaryName"
                            :value="item.dictionaryName">
                    </el-option>
                </el-select>
              <span style="color: red">该话术发送哪些分类的用户，如没有选项可在基础管理-字典管理【226:企微话术人群分类】中添加</span>
            </el-form-item>

          <el-form-item label="状态" prop="status" >
            <el-select v-model="form.status"   placeholder="状态">
              <el-option
                  v-for="item in statusData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>


        </el-form>
    </div>


</template>
<script>
    //导入 HTTP请求方法
    import {
      saveWords,
      getWordsEntity, getValiddictionarylist2
    } from '../../api/api';

    import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component";
    export default {
        components: {ElDialog}, data() {

            return {
                rules: {
                  userAllWords: [
                    {required: true, message: '请输入话术', trigger: 'blur'},
                    {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
                  ],
                  userKeyWords: [
                    {required: true, message: '请输入关键词', trigger: 'blur'},
                    {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
                  ],
                  userClass: [
                    {required: true, message: '请选择用户分类', trigger: 'blur'},

                  ],
                  status: [
                    {required: true, message: '请选择状态', trigger: 'blur'},

                  ],
                },
                form: {
                    id:this.$route.query.id,
                    userAllWords:'',
                    userKeyWords:'',
                    userClass:'',
                    status:'',
                },
              statusData:[{id:1,name:"可用"},{id:0,name:"禁用"}],
              userClassData:[],
              isEdit:false,
            };

        },
        //props:['activeParam'],
        //挂载时候执行
        mounted(){
          getValiddictionarylist2({platformGroupId:1000,dictionaryTypeId:226}).then((res) => {
            if(res.data.success){
              this.userClassData=res.data.value;
              this.getEntity();
            }
          });



        },
        computed: {},
        methods: {

            getEntity(){
                if(this.form.id!=''&&this.form.id!=null) {
                  this.isEdit=true;
                    console.log("id:"+this.form.id);
                  getWordsEntity({id: this.form.id}).then(res => {
                        this.form = res.data.value;
                    });
                }
            },
            saveData(){
                this.$refs.form.validate((valid)=>{
                   if(valid){
                       this.loading = true;
                       console.log(this.form)
                     saveWords(this.form).then((res) => {
                           this.loading = false;
                           if (res.data.status == 200) {
                               this.showDialog = false;
                               this.$message({
                                   message: '保存成功',
                                   type: 'success'
                               });

                               if (this.form.id == ''||this.form.id==null) {
                                   this.form = res.data.value;
                                  //editeActive(this.form);
                               }
                             this.$router.push({
                               path: 'wordsList',
                               name: 'wordsList',
                               query: {

                               }
                             })

                           } else {
                               this.$message({
                                   showClose: true,
                                   message: res.data.message,
                                   type: 'error'
                               });
                           }
                       });
                   }else{
                        //验证不通过
                   }
                });

            },
          returnHistory(){
            window.history.go(-1)
          }


        }
    }
</script>


// WEBPACK FOOTER //
// src/views/distribution/wordsEdit.vue